const STORAGE_KEY = 'commandPalette:v1'
const MAX_RECENTS = 8

export interface PaletteRecent {
  type: string
  id: string
  path: string
  label: string
  at: number
}

const canUseStorage = (): boolean => typeof window !== 'undefined' && !!window.localStorage

export function readPaletteRecents(): PaletteRecent[] {
  if (!canUseStorage()) return []
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as { recents?: PaletteRecent[] }
    if (!Array.isArray(parsed.recents)) return []
    return parsed.recents
      .filter(
        (item) =>
          item &&
          typeof item.id === 'string' &&
          typeof item.path === 'string' &&
          typeof item.label === 'string',
      )
      .slice(0, MAX_RECENTS)
  } catch {
    return []
  }
}

export function writePaletteRecent(entry: Omit<PaletteRecent, 'at'>): PaletteRecent[] {
  const next: PaletteRecent = { ...entry, at: Date.now() }
  const current = readPaletteRecents().filter((item) => item.id !== next.id)
  const recents = [next, ...current].slice(0, MAX_RECENTS)
  if (!canUseStorage()) return recents
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ recents }))
  } catch {
    // ignore quota / private mode
  }
  return recents
}
